export default __webpack_public_path__ + "media/images/just-eat-white-06ddfec342ada22d47cf18ee38593f5f.svg";